import {
	Component, Input, ViewChild, ElementRef, OnDestroy,
	ApplicationRef, createComponent, EnvironmentInjector, Injector
} from '@angular/core';
import { QohPopoverPanelComponent } from './qoh-popover-panel.component';

@Component({
	selector: 'app-qoh-popover',
	template: `
		<div #trigger
			(mouseenter)="onTriggerEnter()"
			(mouseleave)="onTriggerLeave()"
			style="display:inline-block">
			<ng-content></ng-content>
		</div>
	`,
	styles: [`:host { display: inline-block; }`]
})
export class QohPopoverComponent implements OnDestroy {
	@Input() item: { qoh?: any[]; canviewqoh?: number; locqoh?: number } | null = null;
	@ViewChild('trigger') triggerRef: ElementRef<HTMLElement>;

	private panelRef: any = null;

	constructor(
		private appRef: ApplicationRef,
		private injector: Injector,
		private envInjector: EnvironmentInjector
	) {}

	onTriggerEnter() {
		if (this.panelRef) return;
		const ref = createComponent(QohPopoverPanelComponent, {
			environmentInjector: this.envInjector,
			elementInjector: this.injector
		});
		ref.instance.item = this.item;
		this.appRef.attachView(ref.hostView);
		document.body.appendChild(ref.location.nativeElement);
		this.panelRef = ref;

		requestAnimationFrame(() => {
			const el = this.triggerRef?.nativeElement;
			if (el && this.panelRef) {
				const rect = el.getBoundingClientRect();
				this.panelRef.instance.updatePosition(rect);
				this.panelRef.changeDetectorRef.detectChanges();
			}
		});
	}

	onTriggerLeave() {
		this.destroyPanel();
	}

	private destroyPanel() {
		if (this.panelRef) {
			this.appRef.detachView(this.panelRef.hostView);
			this.panelRef.destroy();
			this.panelRef = null;
		}
	}

	ngOnDestroy() {
		this.destroyPanel();
	}
}
